import { ICacheContext } from 'framework/context/ICacheContext';
import { IRfiaFilterData } from 'gen/ApiClient';
import React from 'react';

export const FilterDataContext = React.createContext<ICacheContext<IRfiaFilterData>>(undefined as any);
